import { useCallback, useEffect, useState } from 'react';

export const useOnboardingState = (isAvailable: boolean) => {
  const [onboardingIsOpen, setOnboardingIsOpen] = useState(false);

  const handleOnboardingClose = useCallback(() => setOnboardingIsOpen(false), []);

  useEffect(() => {
    setOnboardingIsOpen(isAvailable);
  }, [isAvailable]);

  return [onboardingIsOpen, handleOnboardingClose] as const;
};
